module.exports = __webpack_public_path__ + "static/media/cartBack1.ba655842.jpg";